import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useEditorStore } from "@sonder/editor/source/core/stores";
import {
  updateSearchTermPositionAction,
  useSearchTermStore,
} from "@sonder/editor/source/core/stores/SearchTermStore";
import { DraftDecoratorComponentProps } from "@sonder/editor/typings/editor";
import { colors } from "@sonder/ui/source/styled/theme";

export const StyledSearchTerm = styled.span`
  color: ${colors.blue7};
`;

export interface SearchTermProps extends DraftDecoratorComponentProps {}
export const SearchTerm = ({ children, entityKey }: SearchTermProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const { state: editorState } = useEditorStore();
  const { dispatch } = useSearchTermStore();

  useEffect(() => {
    if (ref.current)
      dispatch(
        updateSearchTermPositionAction(ref.current.getBoundingClientRect()),
      );
  }, [editorState]);

  return (
    <StyledSearchTerm data-entity-key={entityKey} ref={ref}>
      {children}
    </StyledSearchTerm>
  );
};
